module.exports = __webpack_public_path__ + "static/media/arrows.83972d19.svg";